import React, { Component } from 'react'
import HubItem from './hub-item'

import {
  logo__wrapper__mobile,
  logo__wrapper__desktop,
  container__desktop,
  container__mobile,
  container__mobile__playlist,
  container__nobanner,
  container__nopad,
  container__nopad__mobile,
  container__withpad
} from './style'

class Hub extends Component {
  render() {
    const { hubTitle, hasBanner, list, isMobile, position, isPlaylist } = this.props
    let hubMarginStyle = ''
    if (position == 'bottom' && !isPlaylist) {
      if (isMobile) {
        hubMarginStyle = container__nopad__mobile
      } else {
        hubMarginStyle = container__nopad
      }
    } else if (position == 'bottom' && isPlaylist) {
      if (isMobile) hubMarginStyle = container__withpad
    }

    const containerStyleMobile = isPlaylist ? container__mobile__playlist : container__mobile

    return (
      <div
        className={`${isMobile ? containerStyleMobile : container__desktop} 
        ${hubMarginStyle} 
        ${hasBanner ? '' : container__nobanner}`}
      >
        {hubTitle && <h3>{hubTitle}</h3>}
        <div className={isMobile ? logo__wrapper__mobile : logo__wrapper__desktop}>
          {list.map((obj, idx) => (
            <HubItem data={obj} key={idx} index={idx} isMobile={isMobile} />
          ))}
        </div>
      </div>
    )
  }
}

export default Hub
